import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import CheckboxFilter from '../../atoms/CheckboxFilter'
import Accordion from '@pcln/accordion'
import { Flex } from 'pcln-design-system'

const propTypes = {
  filters: PropTypes.array.isRequired, // one child per filterable item to control show-hides
  handleChange: PropTypes.func.isRequired,
  filterNamePrefix: PropTypes.string,
  className: PropTypes.string,
  hasParentCheckbox: PropTypes.bool,
  wrapLabel: PropTypes.bool,
  isAccordion: PropTypes.bool,
  isParentOptional: PropTypes.bool,
  shouldPadConsistently: PropTypes.bool,
}

const defaultProps = {
  hasParentCheckbox: false,
  wrapLabel: false,
  isAccordion: false,
  isParentOptional: false,
  shouldPadConsistently: false,
}

const CheckboxCategoryWrapper = styled.div``

class CheckboxCategoryGroup extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      filters: props.filters,
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      filters: newProps.filters,
    })
  }

  onChange(event) {
    this.props.handleChange(
      {
        [event.target.value]: event.target.checked,
      },
      event
    )

    if (this.props.hasParentCheckbox) {
      const clickCheckBoxId = parseInt(event.target.id.substr(event.target.id.length - 1))
      const filters = this.state.filters
      if (event.target.value !== filters[0].value) {
        filters[0].checked = false
        filters[clickCheckBoxId].checked = !filters[clickCheckBoxId].checked
      } else {
        filters[0].checked = this.props.isParentOptional ? !filters[0].checked : true
        for (let i = 1; i <= filters.length - 1; i++) {
          filters[i].checked = false
        }
      }
      this.setState({ filters })
    }
  }

  render() {
    const items = this.state.filters.map((filter, index) => {
      // eslint-disable-next-line no-prototype-builtins
      const wrapLabel = filter.hasOwnProperty('wrapLabel') ? filter.wrapLabel : this.props.wrapLabel
      return (
        <CheckboxFilter
          {...filter}
          wrapLabel={wrapLabel}
          checkboxId={`${this.props.filterNamePrefix}-${filter.value}-checkbox-${index}`}
          key={`${filter.value}-checkbox-${index}`}
          shouldPadConsistently={this.props.shouldPadConsistently}
        />
      )
    })
    return (
      <CheckboxCategoryWrapper
        onChange={(e) => {
          this.onChange(e)
        }}
      >
        {this.props.isAccordion ? (
          <Accordion shouldMapOpenPropToContent shouldAnimate={false}>
            <Flex alignItems='center'>
              {items[0]}
              <Accordion.Trigger />
            </Flex>
            <Accordion.Content pl={3}>{items.slice(1)}</Accordion.Content>
          </Accordion>
        ) : (
          items
        )}
      </CheckboxCategoryWrapper>
    )
  }
}

CheckboxCategoryGroup.propTypes = propTypes
CheckboxCategoryGroup.defaultProps = defaultProps

export default CheckboxCategoryGroup
